import React from 'react'

class LostKey extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const item = this.props.item;

    return (
      <div className="card-keys-stamp" >
        <div className="card-row">
          <div className="card-item">
            <p>Avaimen leima</p>
            <div className="card-keys-btn">
              <p>{item.stamp}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default LostKey
